import { ISerializedDesign } from '@studio/domain/creativeset';
import { CreativeUpdate } from '@studio/domain/creativeset/creative/creative';
import { ISerializedVersion } from '@studio/domain/creativeset/version';
import { gql } from './gql.types';

export const CREATE_DESIGNS = gql<{ id: string }, any>`
    mutation CreateDesigns(
        $creativesetId: String!
        $designs: [CreateDesignInputType]!
        $creatives: [UpdateCreativeInputType]!
    ) {
        createDesigns(designs: $designs, creativesetId: $creativesetId, creatives: $creatives) {
            designs {
                id
            }
        }
    }
`;

export const UPDATE_DESIGNS = gql<{ id: string }, any>`
    mutation UpdateDesignsInCreativeset(
        $creativesetId: String!
        $designs: [UpdateDesignInputType]!
        $creatives: [UpdateCreativeInputType]!
    ) {
        updateDesigns(designs: $designs, creativesetId: $creativesetId, creatives: $creatives) {
            designs {
                id
            }
        }
    }
`;

export type DeleteDesignsResult = {
    deleteDesigns: {
        ids: string[];
    };
};

export const DELETE_DESIGNS = gql<DeleteDesignsResult, { designIds: string[]; creativesetId: string }>`
    mutation DeleteDesignsMutation($designIds: [String]!, $creativesetId: String!) {
        deleteDesigns(designIds: $designIds, creativesetId: $creativesetId) {
            ids
        }
    }
`;

type ValidateDesignsResult = {
    validateDesigns: {
        isSuccessful: boolean;
        isValid: boolean;
        errorMessage: string;
    };
};
type ValidateDesignsVariables = {
    creativesetId: string;
    designs: {
        versions: ISerializedVersion[];
        design: ISerializedDesign;
    }[];
    creatives: CreativeUpdate[];
};
export const VALIDATE_DESIGNS = gql<ValidateDesignsResult, ValidateDesignsVariables>`
    mutation ValidateDesignsInCreativeset(
        $creativesetId: String!
        $designs: [UpdateDesignInputType]!
        $creatives: [UpdateCreativeInputType]!
    ) {
        validateDesigns(designs: $designs, creativesetId: $creativesetId, creatives: $creatives) {
            isSuccessful
            isValid
            errorMessage
        }
    }
`;
